import Vue from "vue";
import WirelessKeyboardIcon from "./WirelessKeyboardIcon.vue";
import DepartmentIcon from "./DepartmentIcon.vue";
import QueueIcon from "./QueueIcon.vue";
import BannedWordIcon from "./BannedWordIcon.vue";
import voiceCall from "./voiceCall.vue";
import soundRecordingIcon from "./soundRecordingIcon.vue";
import visitorLocationIcon from "./visitorLocationIcon.vue";
import automaticCallTransfer from "./automaticCallTransfer.vue";
import speechIcon from "./speechIcon.vue";
import representativeFile from "./representativeFile.vue";
import microphoneIcon from "./microphoneIcon.vue";
import customerRepresentativeIcon from "./customerRepresentativeIcon.vue";
import secretMessageIcon from "./secretMessageIcon.vue";
import fileIcon from "./fileIcon.vue";
import visitorClearIcon from "./visitorClearIcon.vue";
import messageIcon from "./messageIcon.vue";
import translationIcon from "./translationIcon.vue";
import videoCallIcon from "./videoCallIcon.vue";
import automaticLoginIcon from "./automaticLoginIcon.vue";
import locationIcon from "./locationIcon.vue";
import writingIcon from "./writingIcon.vue";
import Language1 from "./Language1.vue";
import Language2 from "./Language2.vue";
import Language3 from "./Language3.vue";
import Language4 from "./Language4.vue";
import AnimationIcon from "./AnimationIcon.vue";
import ChatLocation from "./ChatLocation.vue";
import HideIcon from "./HideIcon.vue";
import HideMobile from "./HideMobile.vue";
import TickedIcon from "./TickedIcon.vue";
import DelayTimeIcon from "./DelayTimeIcon.vue";
import AutoLimitIcon from "./AutoLimitIcon.vue";
import fallIcon from "./fallIcon.vue";
import SpeechHideIcon from "./SpeechHideIcon.vue";
import PassiveChatIcon from "./PassiveChatIcon.vue";
import ClosingUserIcon from "./ClosingUserIcon.vue";
import offlineIcon from "./offlineIcon.vue";
import DropdownMenuIcon from "./DropdownMenuIcon.vue";
import AddIcon from "./AddIcon.vue";
import VisitorFormIcon from "./VisitorFormIcon.vue";
import ThemeIcon from "./ThemeIcon.vue";
import FontIcon from "./FontIcon.vue";
import NewHiddenIcon from "./NewHiddenIcon.vue";
import ContactsIcon from "./ContactsIcon.vue";
import TimeZoneIcon from "./TimeZoneIcon.vue";
import SubscriptionIcon from "./SubscriptionIcon.vue";
import MailIcon from "./MailIcon.vue";
import TaskIcon from "./TaskIcon.vue";
import TicketShow from "./ticketShow.vue";
import ChatAiIcon from "./ChatAiIcon.vue";
import MergeIcon from "./MergeIcon.vue";
import CalendarIcon from "./CalendarIcon.vue";
import FabMenuIcon from "./FabMenuIcon.vue";
import PaperShredderIcon from "./PaperShredderIcon.vue";

import Bubble1 from "../bubbles/Bubble1.vue";
import Bubble2 from "../bubbles/Bubble2.vue";
import Bubble3 from "../bubbles/Bubble3.vue";
import Bubble4 from "../bubbles/Bubble4.vue";
import Bubble5 from "../bubbles/Bubble5.vue";
import Bubble6 from "../bubbles/Bubble6.vue";
import Bubble7 from "../bubbles/Bubble7.vue";
import Bubble8 from "../bubbles/Bubble8.vue";
import RoundRobin from "./RoundRobin.vue";
import AIClassificationIcon from "./AIClassificationIcon.vue";
import FormIcon from "./FormIcon.vue";
import SearchAddIcon from "./SearchAddIcon.vue";
import SearchRemoveIcon from "./SearchRemoveIcon.vue";
import AtomicPower from "./AtomicPower.vue";
import MetaIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";

Vue.component("Bubble1", Bubble1);
Vue.component("Bubble2", Bubble2);
Vue.component("Bubble3", Bubble3);
Vue.component("Bubble4", Bubble4);
Vue.component("Bubble5", Bubble5);
Vue.component("Bubble6", Bubble6);
Vue.component("Bubble7", Bubble7);
Vue.component("Bubble8", Bubble8);

Vue.component("WirelessKeyboardIcon", WirelessKeyboardIcon);
Vue.component("DepartmentIcon", DepartmentIcon);
Vue.component("QueueIcon", QueueIcon);
Vue.component("BannedWordIcon", BannedWordIcon);
Vue.component("voiceCall", voiceCall);
Vue.component("soundRecordingIcon", soundRecordingIcon);
Vue.component("visitorLocationIcon", visitorLocationIcon);
Vue.component("automaticCallTransfer", automaticCallTransfer);
Vue.component("speechIcon", speechIcon);
Vue.component("representativeFile", representativeFile);
Vue.component("microphoneIcon", microphoneIcon);
Vue.component("customerRepresentativeIcon", customerRepresentativeIcon);
Vue.component("secretMessageIcon", secretMessageIcon);
Vue.component("fileIcon", fileIcon);
Vue.component("visitorClearIcon", visitorClearIcon);
Vue.component("messageIcon", messageIcon);
Vue.component("translationIcon", translationIcon);
Vue.component("videoCallIcon", videoCallIcon);
Vue.component("automaticLoginIcon", automaticLoginIcon);
Vue.component("locationIcon", locationIcon);
Vue.component("writingIcon", writingIcon);
Vue.component("Language1", Language1);
Vue.component("Language2", Language2);
Vue.component("Language3", Language3);
Vue.component("Language4", Language4);
Vue.component("AnimationIcon", AnimationIcon);
Vue.component("ChatLocation", ChatLocation);
Vue.component("HideIcon", HideIcon);
Vue.component("HideMobile", HideMobile);
Vue.component("TickedIcon", TickedIcon);
Vue.component("DelayTimeIcon", DelayTimeIcon);
Vue.component("AutoLimitIcon", AutoLimitIcon);
Vue.component("fallIcon", fallIcon);
Vue.component("SpeechHideIcon", SpeechHideIcon);
Vue.component("PassiveChatIcon", PassiveChatIcon);
Vue.component("ClosingUserIcon", ClosingUserIcon);
Vue.component("offlineIcon", offlineIcon);
Vue.component("DropdownMenuIcon", DropdownMenuIcon);
Vue.component("AddIcon", AddIcon);
Vue.component("VisitorFormIcon", VisitorFormIcon);
Vue.component("ThemeIcon", ThemeIcon);
Vue.component("FontIcon", FontIcon);
Vue.component("NewHiddenIcon", NewHiddenIcon);
Vue.component("ContactsIcon", ContactsIcon);
Vue.component("TimeZoneIcon", TimeZoneIcon);
Vue.component("SubscriptionIcon", SubscriptionIcon);
Vue.component("MailIcon", MailIcon);
Vue.component("RoundRobin", RoundRobin);
Vue.component("TicketShow", TicketShow);
Vue.component("CalendarIcon", CalendarIcon);
Vue.component("TaskIcon", TaskIcon);
Vue.component("ChatAiIcon", ChatAiIcon);
Vue.component("MergeIcon", MergeIcon);
Vue.component("AIClassificationIcon", AIClassificationIcon);
Vue.component("FormIcon", FormIcon);
Vue.component("search-add", SearchAddIcon);
Vue.component("search-remove", SearchRemoveIcon);
Vue.component("atomic-power", AtomicPower);
Vue.component("fab-menu", FabMenuIcon);
Vue.component("MetaIcon", MetaIcon);
Vue.component("PaperShredderIcon", PaperShredderIcon)
